import { CardContent, Grid, Typography } from '@mui/material'
import { useTranslate, useShowContext, ReferenceField } from 'react-admin'
import { ShowBase } from '../../components/base'
import { PRODUCT_REVIEWS_FIELDS } from '../../providers/localization/constant'
import { ContentWrapper, Heading, TextFieldStyled } from '../../components/domains/products'
import { DateField, RatingField } from '../../components/fields'
import { UpdateStatusButton } from '../../components/domains/products-reviews'

const RESOURCE_PREFIX = 'resources.product_reviews.show'

const ReviewDetail = (): JSX.Element => {
  const { record, error, isLoading } = useShowContext()
  const translate = useTranslate()
  return (
    <Grid container spacing={3} sx={{ padding: '16px 16px 0' }}>
      {!isLoading && (
        <>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.score.label`)}</Heading>
                <RatingField source='score' size='large' />
              </ContentWrapper>
            </Grid>
            <Grid item xs={12}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.full_name.label`)}</Heading>
                <TextFieldStyled source='full_name' emptyText='-' />
              </ContentWrapper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.product.label`)}</Heading>
                <ReferenceField source='product_id' reference='products'>
                  <TextFieldStyled source='prod_name_th' emptyText='-' />
                </ReferenceField>
              </ContentWrapper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.product_group.label`)}</Heading>
                <ReferenceField source='product_id' reference='products'>
                  <TextFieldStyled source='product_group_title_th' emptyText='-' />
                </ReferenceField>
              </ContentWrapper>
            </Grid>

            <Grid item xs={12}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.subject.label`)}</Heading>
                <TextFieldStyled source='subject' emptyText='-' />
              </ContentWrapper>
            </Grid>
            <Grid item xs={12}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.message.label`)}</Heading>
                <TextFieldStyled source='message' emptyText='-' />
              </ContentWrapper>
            </Grid>
            <Grid item xs={12}>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.create_at.label`)}</Heading>
                <DateField source='create_at' emptyText='-' showTime sx={{ fontSize: '1rem' }} />
              </ContentWrapper>
            </Grid>
            <Grid item>
              <ContentWrapper>
                <Heading>{translate(`${PRODUCT_REVIEWS_FIELDS}.is_active.label`)}</Heading>
                <UpdateStatusButton record={record} />
              </ContentWrapper>
            </Grid>
          </Grid>
        </>
      )}
      {isLoading && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Loading...</Typography>
          </Grid>
        </Grid>
      )}
      {error && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Error cannot load resource, please contact admin</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

const ReviewShow = (): JSX.Element => {
  return (
    <ShowBase
      title={`${RESOURCE_PREFIX}.title`}
      listAction={{ hasList: true, hasEdit: false, hasBackButton: true }}
    >
      <>
        <CardContent>
          <ReviewDetail />
        </CardContent>
      </>
    </ShowBase>
  )
}

export default ReviewShow
